// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import useExpandProps from "@store/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

interface OwnProps {
    heading: string;
    text: string | number;
    extendedStyles?: SmallHeadingAndTextStyles;
    // Starter Custom Code
    overridedStyles?: SmallHeadingAndTextStyles;
}

export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    // Starter Removed - extendedStyles
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    heading: {
        variant: "legend",
    },
    text: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
};

const SmallHeadingAndText: React.FunctionComponent<OwnProps> = ({
    heading,
    text,
    extendedStyles,
    overridedStyles, // Starter Custom Code
    ...otherProps
}) => {
    const styles = useExpandProps(smallHeadingAndTextStyles, extendedStyles, overridedStyles); // Starter Custom Code

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            <Typography as="p" {...styles.heading} data-test-selector="heading">
                {heading}
            </Typography>
            <Typography as="p" {...styles.text} data-test-selector={`text_${heading}`}>
                {text}
            </Typography>
        </StyledWrapper>
    );
};

export default SmallHeadingAndText;
